// extracted by mini-css-extract-plugin
export var affiliatewrapper = "moshimoaffiliate-module--affiliatewrapper--1e90c";
export var amazonbuttonstyle = "moshimoaffiliate-module--amazonbuttonstyle--9af4b";
export var buttonswrapper = "moshimoaffiliate-module--buttonswrapper--64233";
export var img = "moshimoaffiliate-module--img--abc31";
export var imgbuttonwrapper = "moshimoaffiliate-module--imgbuttonwrapper--f3d75";
export var rakutenbuttonstyle = "moshimoaffiliate-module--rakutenbuttonstyle--77ea2";
export var text = "moshimoaffiliate-module--text--9e3e1";
export var title = "moshimoaffiliate-module--title--1914e";
export var yahoobuttonstyle = "moshimoaffiliate-module--yahoobuttonstyle--916e3";